import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "label", "hasError", "startAdornment", "isFullWidth", "endAdornment", "extraDescription", "helperText", "disabled", "readonly", "showValidState", "validStateIconSize", "placeholder", "formFieldType", "children", "className"];
import React from 'react';
import { FormFieldStyles } from "./FormField.styles.js";
export var FormField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    hasError = _ref.hasError,
    startAdornment = _ref.startAdornment,
    isFullWidth = _ref.isFullWidth,
    endAdornment = _ref.endAdornment,
    extraDescription = _ref.extraDescription,
    helperText = _ref.helperText,
    disabled = _ref.disabled,
    readonly = _ref.readonly,
    showValidState = _ref.showValidState,
    _ref$validStateIconSi = _ref.validStateIconSize,
    validStateIconSize = _ref$validStateIconSi === void 0 ? 16 : _ref$validStateIconSi,
    placeholder = _ref.placeholder,
    formFieldType = _ref.formFieldType,
    children = _ref.children,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(FormFieldStyles.Wrapper, _extends({
    "data-testid": "".concat(formFieldType, "-wrapper")
  }, otherProps, {
    ref: ref,
    $isFullWidth: isFullWidth,
    "aria-disabled": disabled,
    "aria-readonly": readonly,
    className: className
  }), extraDescription ? /*#__PURE__*/React.createElement(FormFieldStyles.ExtraDescription, {
    "data-testid": "".concat(formFieldType, "-extra-description")
  }, extraDescription) : null, /*#__PURE__*/React.createElement(FormFieldStyles.InnerWrapper, {
    $hasError: hasError,
    $disabled: disabled || readonly,
    htmlFor: id
  }, startAdornment ? /*#__PURE__*/React.createElement(FormFieldStyles.AdornmentWrapper, {
    "data-testid": "".concat(formFieldType, "-start-adornment")
  }, startAdornment) : null, /*#__PURE__*/React.createElement(FormFieldStyles.ValueWrapper, null, children, /*#__PURE__*/React.createElement(FormFieldStyles.LabelText, {
    $hasError: hasError,
    $disabled: disabled || readonly
  }, label)), endAdornment ? /*#__PURE__*/React.createElement(FormFieldStyles.AdornmentWrapper, {
    "data-testid": "".concat(formFieldType, "-end-adornment")
  }, endAdornment) : null, showValidState ? /*#__PURE__*/React.createElement(FormFieldStyles.AdornmentWrapper, {
    "data-testid": "".concat(formFieldType, "-end-valid-state-adornment")
  }, /*#__PURE__*/React.createElement(FormFieldStyles.GreenTickIcon, {
    size: validStateIconSize
  })) : null), helperText ? /*#__PURE__*/React.createElement(FormFieldStyles.HelperText, {
    "data-testid": "".concat(formFieldType, "-helper-text"),
    $hasError: hasError
  }, helperText) : null);
});